import { Component, Input, OnInit } from '@angular/core';
import Chart from 'chart.js/auto';

@Component({
    selector: 'app-service-health-line-chart',
    templateUrl: './service-health-line-chart.component.html',
    styleUrls: ['./service-health-line-chart.component.scss'],
})
export class ServiceHealthLineChartComponent implements OnInit {
    @Input() recievedServiceHealthData: any;

    constructor() { }

    ngOnInit(): void {
        this.createLineChart();
    }

    createLineChart(): void {
        const ctx = document.getElementById(
            'service-health-line-chart'
        ) as HTMLCanvasElement;
        const ctx2D = ctx.getContext('2d');
        const gradient = ctx2D.createLinearGradient(0, 0, 0, ctx.height);
        gradient.addColorStop(0, '#33d490');
        gradient.addColorStop(0.5, '#fcd087');
        gradient.addColorStop(1, '#ce3632');

        const labels = this.recievedServiceHealthData?.map(
            (item) => item.summary_date
        );
        const data = this.recievedServiceHealthData?.map(
            (item) => item.global_success_rate
        );


        console.log("daya", data);
        new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Service Health',
                        data: data,
                        borderColor: gradient,
                        borderWidth: 4,
                        pointBorderWidth: 0,
                        fill: false,
                    },
                ],
            },
            options: {
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                    },
                },
                elements: {
                    line: {
                        tension: 0.4,
                    },
                    point: {
                        radius: 0,
                    },
                },
                scales: {
                    x: {
                        display: true,
                        title: {
                            display: true,
                        },
                        grid: {
                            display: false,
                        },
                        ticks: {
                            padding: 0,
                        },
                    },
                    y: {
                        display: true,
                        title: {
                            display: true,
                        },
                        min: 0,
                        max: 100,
                        grid: {
                            display: true,
                            color: '#ececec',
                        },
                        ticks: {
                            stepSize: 10,
                            font: {
                                size: 12,
                            },
                            color: '#777777',
                            callback: function (value) {
                                return value + '%';
                            },
                            padding: 0,
                        },
                    },
                },
                layout: {
                    padding: {
                        left: 0,
                        bottom: 0,
                    },
                },
            },
        });
    }
}
